<div *ngIf="dateien">
  <h1>{{ 'Dateianhänge' | translate }}</h1>

  <ion-list>
    <ion-item *ngFor="let p of dateien" class="ion-no-padding" lines="none" appClick (clicked)="onItemClicked($event, p)" >
      <ion-avatar slot="start">
          <img *ngIf="p.icon == 'pdf'" src="/assets/icon/pdf-64.png">
          <img *ngIf="p.icon == 'png'" src="/assets/icon/png.png">
          <img *ngIf="p.icon == 'jpg'" src="/assets/icon/jpg.png">
          <img *ngIf="p.icon == 'document'" src="/assets/icon/document.png">
      </ion-avatar>
      <ion-label>
        <h2>{{ p.Dateiname }}</h2>
      </ion-label>
    </ion-item>
  </ion-list>
</div>